import React, {useEffect, useState} from 'react';
import {Row, Col, Pagination, Box, Button} from 'adminlte-2-react';
import {useSelector, useDispatch} from 'react-redux';
import {getDateUtcOrEmpty} from '../utils/utils';
import Loader from '../utils/Loader';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {EditIcon} from '../ui/icons';
import {Alert} from '../utils/Alert';
import {CustomBox} from '../ui/layout/CustomBox';
import {usuariosGetDuck, usuariosGetThunk} from './duck';
import {constants, responseSelector} from '../utils/utils';
import {rolDescByName} from '../utils/constants';
import {alertTypes} from '../utils/Alert';
import DeleteIcon from '@mui/icons-material/Delete';
import {SearchFilterContainer} from '../ui/filters/SearchFilter';
import {usuarioEditDuck, usuarioEditThunk} from './duck';
import {ModalGenerico} from '../ui/ModalGenerico';
import {Content} from '../ui/Content';
import {TextInput} from '../utils/TextInput';

function UsuariosList({history, match, token}) {
  const dispatch = useDispatch();
  const alertDefaultValue = {
    text: null,
    type: null,
    title: null,
    closable: false,
  };
  const modelUsuarios = useSelector(state => state.usuariosGet);
  const usuarioEdit = useSelector(state => state.usuarioEdit);
  const [topAlert, setTopAlert] = useState(alertDefaultValue);
  const [loading, setLoading] = useState(true);
  const [usuarios, setUsuarios] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selected, setSelected] = useState('');

  const [busquedaRapida, setBusquedaRapida] = useState('');

  useEffect(() => {
    const data = modelUsuarios?.data?.data;
    const error = modelUsuarios?.error?.message;

    if (error) {
      alert(error);
      dispatch(usuariosGetDuck.actions.clear());
      setLoading(false);
    }

    if (data) {
      setUsuarios(data.data.items);
      setTotalResults(data.data.total);
      setLoading(false);
      dispatch(usuariosGetDuck.actions.clear());
    }
  }, [modelUsuarios]);

  useEffect(() => {
    dispatch(
      usuariosGetThunk({
        userToken: token.raw,
        page: 1,
        estado: 'activo',
      }),
    );
  }, []);

  function handlePage(page) {
    setLoading(true);
    setActivePage(page);
    dispatch(
      usuariosGetThunk({
        userToken: token.raw,
        page: page + 1,
        estado: 'activo',
        busquedaRapida,
      }),
    );
  }

  function deshabilitarUsuario() {
    const data = {
      userToken: token.raw,
      credentialID: selected.credentialID,
      activo: 'false',
    };
    console.log({data});
    dispatch(usuarioEditThunk(data));
  }

  useEffect(() => {
    const {httpStatus, error, errorMessage} = responseSelector(usuarioEdit);

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });
      dispatch(usuarioEditDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      setTopAlert({
        title: 'Éxito',
        text: 'Usuario inhabilitado',
        type: alertTypes.success,
        closable: false,
      });
      handlePage(0);
      setSelected(null);
      dispatch(usuarioEditDuck.actions.clear());
    }
  }, [usuarioEdit]);

  const submitSearchOnEnterPress = event => {
    if (
      event.which === constants.ENTER_KEY_EVENT_CODE ||
      event.keyCode === constants.ENTER_KEY_EVENT_CODE
    ) {
      handlePage(0);
    }
  };

  return (
    <Content title="Usuarios" show={false} history={history}>
      <ModalGenerico
        isModalShown={!!selected}
        hideModal={() => setSelected(null)}
        title="Desactivar"
        body="Se desactivará el usuario. ¿Continuar?"
        buttonText="Desactivar"
        buttonType="danger"
        buttonDisabled={usuarioEdit.loading}
        buttonLoading={usuarioEdit.loading}
        submit={deshabilitarUsuario}
      />
      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Filtro">
            <Col md="3">
              <TextInput
                label="Búsqueda rápida"
                placeholder="Nombre, ruc"
                initialValue={busquedaRapida}
                setValue={setBusquedaRapida}
                onKeyDown={event =>
                  submitSearchOnEnterPress(event, () => handlePage(0))
                }
              />
            </Col>
            <Col md="12">
              <div style={{float: 'right'}}>
                <div style={{display: 'inline-block', marginRight: 10}}>
                  <Button
                    type="primary"
                    text="Filtrar"
                    onClick={() => handlePage(0)}
                  />
                </div>
              </div>
            </Col>
          </Box>
        </Col>
        <Col md="10" mdOffset="1">
          <CustomBox
            title={'Usuarios'}
            showBackButton
            history={history}
            onBackPress={() => history.push('/obras')}>
            {topAlert.text && (
              <Alert
                title={topAlert.title}
                type={topAlert.type}
                text={topAlert.text}
                closable={topAlert.closable}
              />
            )}
            <SearchFilterContainer
              onAdd={() => history.push(`/usuario/agregar`)}
              addButtonText="Agregar"
              showAddButton={true}
              child={<></>}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
            <Loader isLoading={loading}>
              {usuarios && usuarios.length > 0 ? (
                <div className="table-responsive">
                  <DataTable
                    lazy
                    pt={{
                      table: {
                        className: 'table table-hover',
                      },
                    }}
                    value={usuarios}
                    emptyMessage="No se encontraron registros">
                    <Column
                      header="Acciones"
                      body={usuario => (
                        <div style={{display: 'inline-block'}}>
                          <ButtonWithLoading
                            text={<EditIcon style={{}} />}
                            type="default"
                            size="sm"
                            submit={() =>
                              history.push(
                                `/usuario/editar/${usuario.credentialID}`,
                              )
                            }
                          />
                          <div
                            style={{display: 'inline-block', marginLeft: 10}}>
                            <ButtonWithLoading
                              text={<DeleteIcon style={{color: 'white'}} />}
                              type="danger"
                              size="sm"
                              submit={() => {
                                setSelected(usuario);
                              }}
                            />
                          </div>
                        </div>
                      )}></Column>

                    <Column
                      field="nombre"
                      header="Nombre"
                      body={usuario => usuario.nombre}></Column>

                    <Column
                      field="email"
                      header="Email"
                      body={usuario => usuario.email}></Column>

                    <Column
                      field="rol"
                      header="Rol"
                      body={usuario =>
                        usuario.rol ? rolDescByName[usuario.rol] : 'NA'
                      }></Column>

                    <Column
                      header="Fecha de creación"
                      body={usuario =>
                        getDateUtcOrEmpty(usuario.tsCreated)
                      }></Column>
                  </DataTable>
                </div>
              ) : (
                <h4>No se han encontrado usuarios</h4>
              )}
            </Loader>

            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </CustomBox>
        </Col>
      </Row>
    </Content>
  );
}

export default UsuariosList;
